/**
 * Generation Steps Configuration
 * Defines the steps shown during collateral generation
 */

export const DEFAULT_GENERATION_STEPS = [
  'Analyzing company intelligence and prospect data',
  'Researching industry trends and competitive landscape',
  'Gathering relevant content and insights',
  'Crafting personalized messaging and value propositions',
  'Designing visual layout and structure',
  'Optimizing content for engagement and conversion',
  'Reviewing and refining the collateral',
  'Finalizing and preparing your collateral',
];

/**
 * Default generation configuration
 */
export const DEFAULT_GENERATION_CONFIG = {
  duration: 240000, // 4 minutes in milliseconds
  stepDuration: 30000, // 30 seconds per step
  steps: DEFAULT_GENERATION_STEPS,
};

/**
 * Get generation steps with custom configuration
 * @param {Object} config - Custom configuration
 * @returns {Array<string>} Array of step strings
 */
export const getGenerationSteps = (config = {}) => {
  return config.steps || DEFAULT_GENERATION_STEPS;
};

